import { render, staticRenderFns } from "./moreButton.vue?vue&type=template&id=e8ff4676&scoped=true"
import script from "./moreButton.vue?vue&type=script&lang=js"
export * from "./moreButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ff4676",
  null
  
)

export default component.exports